import React, { useState, useEffect, useContext } from "react";
import { Typography, IconButton, Tooltip, Stack, Divider } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getCreditsPendienteAsync } from "../../../api/Dashboard";

const PendieteCredits = () => {
  const [totalNoDesembolsado, setNoDesembolsado] = useState(0);
  const { setIsLoading, setIsLogged, setIsUnautorized } =
    useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getCreditsPendienteAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setNoDesembolsado(result.data.result);
    })();
  }, []);

  return (
    <div>
      <Stack
        direction={"row"}
        style={{ padding: 10 }}
        justifyContent="space-between"
        alignItems={"center"}
      >
        <Tooltip title="Ver Créditos no Desembolsados">
          <IconButton
            sx={{ border: 1, borderColor: "rgba(153, 102, 255, 1)" }}
            style={{
              width: 100,
              height: 100,
              backgroundColor: "rgba(153, 102, 255, 0.2)",
            }}
            onClick={() => navigate(`${ruta}/clients`)}
          >
            <FontAwesomeIcon
              icon={faUsersSlash}
              style={{
                fontSize: 60,
                color: "rgba(153, 102, 255, 1))",
                opacity: 0.3,
                padding: 10,
              }}
            />
          </IconButton>
        </Tooltip>
        <Typography
          align="right"
          style={{
            color: "rgba(153, 102, 255, 1)",
            fontWeight: 800,
            fontSize: 30,
          }}
          paragraph
        >
          {totalNoDesembolsado}
        </Typography>
      </Stack>
      <Divider />
      <Typography
        variant="subtitle1"
        align="center"
        style={{ color: "rgba(153, 102, 255, 1)", fontSize: 20 }}
      >
        No Desembolsados
      </Typography>
    </div>
  );
};

export default PendieteCredits;
